import ChooseTypeOfClientModal from "./ChooseTypeOfClientModal";

export default ChooseTypeOfClientModal;
